import Vue from 'vue'
import '@/assets/css/common.less'
// import { Table, TableColumn } from 'element-ui'
import App from './App.vue'
import router from './router'
import * as echarts from 'echarts'
import ECharts from 'vue-echarts'
import axios from 'axios'
import VueAxios from 'vue-axios'

window.echarts = echarts
import '@/assets/js/china.js'
// Vue.use(Table).use(TableColumn)
Vue.component('v-chart', ECharts)
Vue.use(VueAxios, axios)
Vue.config.productionTip = false

new Vue({
  router,
  // store,
  data: function() {
    return {
      apiBaseUrl: 'http://ys.cnais.org.cn/',
      sourceBaseUrl: 'http://ys.cnais.org.cn/',
      view_type: 'pc',
      eventHub: new Vue()
    }
  },
  render: h => h(App)
}).$mount('#app')
